export default __webpack_public_path__ + "static/image-cv-web-5a9272874e05ac71be5e055a6738e8da.png";